import type { ReactNode } from 'react';
import { cx } from '../../lib/cx';

/**
 * Small outlined pill for facts about a row ("In progress", "Ends 31 Oct"). For a status colour use StatusTag.
 * `md` is the 26px skill chip in the staff table (Figma A04).
 */
export function Chip({
  children,
  size = 'sm',
  className,
}: {
  children: ReactNode;
  size?: 'sm' | 'md';
  className?: string;
}) {
  return (
    <span
      className={cx(
        'inline-flex items-center whitespace-nowrap rounded-full border border-border-default text-text-secondary',
        size === 'md'
          ? 'h-(--mbm-size-chip-md) px-(--mbm-space-2-5) text-body-xsmall font-semibold text-text-primary'
          : 'h-(--mbm-space-5) px-(--mbm-space-2) text-label-tag',
        className,
      )}
    >
      {children}
    </span>
  );
}
